import { Card, CardMedia, Typography, Box } from "@mui/material";

interface VideoPlayerProps {
  streamData: {
    youtube_stream_link?: string;
    title?: string;
    type_of_service?: string;
  } | null;
  borderRadius?: string;
}

export default function VideoPlayer({
  streamData,
  borderRadius = "20px",
}: VideoPlayerProps) {
  const getYouTubeVideoId = (url: string) => {
    const regExp =
      /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:watch\?v=|embed\/|v\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
    const match = url.match(regExp);
    return match && match[1] ? match[1] : null;
  };

  const videoId = streamData?.youtube_stream_link
    ? getYouTubeVideoId(streamData.youtube_stream_link)
    : null;

  const embedUrl = videoId
    ? `https://www.youtube.com/embed/${videoId}?autoplay=0&controls=1&modestbranding=1&rel=0`
    : "about:blank";

  return (
    <Card
      sx={{
        // mb: { xs: 2, md: 4 },

        overflow: "hidden",
        boxShadow: 0,
        flexGrow: 1,
        width: "100%",
        borderRadius,
      }}
    >
      <Box
        sx={{
          position: "relative",
          aspectRatio: "16/9",
          bgcolor: "black",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
        }}
      >
        {streamData?.youtube_stream_link ? (
          <CardMedia
            component="iframe"
            src={embedUrl}
            title={streamData.title || "Memorial Service"}
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              border: "none",
            }}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            referrerPolicy="strict-origin-when-cross-origin"
          />
        ) : (
          <Typography variant="h6" color="white">
            Livestream link not available yet.
          </Typography>
        )}
      </Box>
    </Card>
  );
}
